import "./InfoCards.css";
import aboutImg from "../assets/about-bg.jpg";

export default function About() {
  return (
    <section id="about" className="about-section">

      {/* Bild oben */}
      <div 
        className="about-image"
        style={{ backgroundImage: `url(${aboutImg})` }}
      />

      {/* Eigene About Card */}
      <div className="about-card">
        <h2>Über uns</h2>
        <p>
          AF Dienstleistungen steht für Zuverlässigkeit, Sauberkeit und professionelle Arbeit.
          Wir betreuen private und gewerbliche Kunden mit einem breiten Leistungsspektrum rund um
          Gebäude, Garten und Serviceleistungen.
        </p>
      </div>

    </section>
  );
}